<div class="view-wrapper">
  <h3 class="help-center__title">{{ 'HelpCenterComponent.title' | translate }}</h3>
  <table mat-table [dataSource]="helpCenterSettingsDataSource" class="mat-elevation-z6">
    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef>{{ 'HelpCenterComponent.name' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
    </ng-container>
    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef>{{ 'HelpCenterComponent.active' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle color="primary" [checked]="element.enabled" [(ngModel)]="element.enabled"></mat-slide-toggle>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="helpCenterSettingsColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: helpCenterSettingsColumns"></tr>
  </table>
  <button mat-raised-button class="save-button" color="primary" (click)="saveSettings()">
    {{ 'HelpCenterComponent.saveChanges' | translate }}
  </button>
</div>
